import styled from 'styled-components';

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  & video {
    object-fit: fill;
  }
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;
export const Overlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.palette.transparent2};
  z-index: 5;
`;
